import { render, staticRenderFns } from "./company-balance-add.vue?vue&type=template&id=2a6adb38&"
import script from "./company-balance-add.ts?vue&type=script&lang=ts&"
export * from "./company-balance-add.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports